<template>

  <popup
    button-style="text"
    :button-class="buttonStyle"
    heading="Tower Provider Sites"
    :button-text="name"
    button-size="mini"
    :show-save="false"
    button-icon="fa fa-grid">

    <popup-sites-report :name="name" :site-group="siteGroup" :supplier-id="supplierId" :status="status" />

  </popup>

</template>



<script>

import PopupSitesReport from '@/components/dashboard/sites/PopupSitesReport'


export default {

  components: {
    PopupSitesReport
  },

  props: {

    name: {
      type: String,
      required: true
    },

    siteGroup: {
      type: Number,
      default: null
    },

    supplierId: {
      type: Number,
      default: null
    },

    status: {
      type: String,
      default: null
    }

  },


  computed: {
    buttonStyle: function () {

      switch (this.status) {

        case 'Candidate':
          return 'text-warning'

        case 'Dismantled':
          return 'text-danger'

        case 'Active':
          return 'text-primary'

        case 'Exclusive':
          return 'text-black'

        case 'Land-Only':
          return 'text-muted'

        case 'New':
          return 'text-success'

        case 'Temporary':
          return 'text-info'

      }

      return 'text-info'
    }
  }

}

</script>



// WEBPACK FOOTER //
// SitesPopup.vue?a9605eaa